import { isNotNull } from "./object"

export const onSetNewState = (self, newState = {}, callback) => {
    if (isNotNull(self)) {
        if (isNotNull(newState) && self.mounted) {
            self.setState(newState, callback)
        }
    }
}